import { render, staticRenderFns } from "./IconConversation.vue?vue&type=template&id=239f47f0&"
import script from "./IconConversation.vue?vue&type=script&lang=js&"
export * from "./IconConversation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports